import '../src/css/App.scss';
import Onboarding from './pages/Onboarding';

function App() {
  return (
    <div className="App">
      <Onboarding/>
    </div>
  );
}

export default App;
